import {createApp} from 'vue'
import CreatePost from './CreatePost'

const el = '.kb-component--create-post'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreatePostDOM)=>{
            const props = {
                groupName: CreatePostDOM.dataset.groupName ?? "",
                groupDescription : CreatePostDOM.dataset.groupDescription ?? "",
                groupId: CreatePostDOM.dataset.groupId ?? "",
                postId: CreatePostDOM.dataset.postId ?? "",
                content: CreatePostDOM.dataset.content ? JSON.parse(CreatePostDOM.dataset.content) : null,
            }
            const component = createApp(CreatePost, props).use(Store)
            component.mount(CreatePostDOM)
        })
    }
}